import { Navigate, Route, Routes } from 'react-router';
import './App.css';
import { ToastContainer } from 'react-toastify';
import SideMenu from './components/layout/side-menu/SideMenu';
import Redirector from './components/redirector/Redirector';
import Login from './pages/login/Login';
import DashboardUser from './pages/dashboard/dashboard-user/DashboardUser';
import DashboardDoorTags from './pages/dashboard/dashboard-tag/DashboardDoorTags';
import DashboardUserTags from './pages/dashboard/dashboard-tag/DashboardUserTags';
import DashboardDoor from './pages/dashboard/dashboard-door/DashboardDoor';
import ProtectedRouteRole from './components/protected/ProtectedRouteRole';
import Footer from './components/layout/footer/Footer';
import DashboardHistory from './pages/dashboard/dashboard-history/DashboardHistory';
import { rolePath } from './config/role';



function App() {
  return (
    <>
    <ToastContainer/>
      <div className='container-fluid app'>
        {/* <div className='row'></div> */}
        <div id='content-div' className='content'>
          <SideMenu/>
          <div className="page-content">
            <Routes>
              <Route path="/" element={<Redirector roleHomes={rolePath}/>} />
              <Route path="/login" element={<Login/>} />
              <Route path="/users" element={<ProtectedRouteRole authorizedRoles={["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"]} children={<DashboardUser/>}/>}/>
              <Route path="/doors" element={<ProtectedRouteRole authorizedRoles={["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"]} children={<DashboardDoor/>}/>}/>
              <Route path="/tag/doors" element={<ProtectedRouteRole authorizedRoles={["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"]} children={<DashboardDoorTags/>}/>} />
              <Route path="/tag/users" element={<ProtectedRouteRole authorizedRoles={["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"]} children={<DashboardUserTags/>}/>} />
              <Route path="/history" element={<ProtectedRouteRole authorizedRoles={["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"]} children={<DashboardHistory/>}/>} />
              {/* altre route */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          
          </div>
          
        </div>
        <Footer />
        {/* <div className='row'></div> */}
      </div>
    </>
  );
}

export default App;
